import React, { Component } from 'react';

import './historialHome.css';

import LogoDownload from '../../../img/logoDownload.png';
import LogoExcel from '../../../img/logoExcel.png';
import LogoBot from '../../../img/IconBot.png';

import LogoUser from '../../../img/LogoUserProfile.png';
import IconInfo from '../../../img/IconsInfo.png';
import IconInfoUser from '../../../img/IconInfoUser.png';

import Functions from '../../../functions/Historial/handleHistorial.js';

class Historial extends Component{

    constructor(props){
        super(props);
        this.state = {
            cantidadSesiones: 0,
            data: null
        }

        this.getCntSesiones();
        this.getCntMensajes();
    }

    getCntSesiones = async () => {
        
        const data = await Functions.getUsuarios();
        if(data){
            let cnt = data.sesiones.length;
            this.setState({cantidadSesiones: cnt});
        }
        // console.log(this.state.cantidadSesiones);
    }

    getCntMensajes = async () => {
        const data = await Functions.getHistoriales();
        // let body = this.state.data;
        // body = data;
        // console.log('data :', data);

        // for (const [k, v] of data.entries()) {
        //     console.log(k, v)
        // }
    }

    renderUserCard = () => {

        const data = Functions.getHistoriales();
        // console.log('data :', data.Promise);

        let el = [];
        if(this.state.cantidadSesiones !== 0 ){
            let cntSesiones = this.state.cantidadSesiones;

            for (let index = cntSesiones-1; index >= 0; index--) {
                el.push(
                <div key={index} className='col s12 x12 userProfile'>
                    <div className='imgUserProfile'>
                        {/* <img src={LogoUser} alt='imgUser'/> */}
                    </div>
                    <div className='textUserProfile'>
                        <p>Usuario {index}</p>
                        <p>Préstamos rotativo</p>
                    </div>
                    <div className='horaChat'>
                        <p>4:30 pm</p>
                    </div>
                </div>)
            }
        }
        return el;
    }

    render(){
        return(
            <div className='row contenedorHistorial'>
                <div className='col s9 x9'>
                    <div className='row'>
                        <div className='col s12 x12 headHistorial'>
                            <div className='col s6 x6' style={{paddingLeft: 0 + 'em'}}>
                                <div className='btnDescargarExcel'>
                                    <img src={LogoDownload} alt='dd' />
                                    <p>Descargar Excel</p>
                                    <img src={LogoExcel} alt='Excel' />
                                </div>
                            </div>
                            <div className='col s6 x6 periodoTiempo'>
                                <p>SEMANA</p>
                                <p>MES</p>
                                <p>AÑO</p>
                            </div>
                        </div>
                    </div>
                    <div className='row'>
                        <div className='col s12 x12 card-panel historial-card'>
                            <div className='col s3 x3 cardUsuario'>
                                <div className='row userList'>
                                    
                                    {/* <div className='col s12 x12 userProfile'>
                                        <div className='imgUserProfile'>
                                            <img src={LogoUser} alt='imgUser'/>
                                        </div>
                                        <div className='textUserProfile'>
                                            <p>Adonay Santos</p>
                                            <p>Préstamos rotativo</p>
                                        </div>
                                        <div className='horaChat'>
                                            <img src={IconInfo} alt='infoHora'/>
                                            <p>4:30 pm</p>
                                        </div>
                                    </div>
                                    <div className='col s12 x12 userProfile selecHistory'>
                                        <div className='imgUserProfile'>
                                            <img src={LogoUser} alt='imgUser'/>
                                        </div>
                                        <div className='textUserProfile'>
                                            <p>Adonay Santos</p>
                                            <p>Préstamos rotativo</p>
                                        </div>
                                        <div className='horaChat'>
                                            <img src={IconInfo} alt='infoHora'/>
                                            <p>4:30 pm</p>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                            <div className='col s9 x8 tablaChats'>
                                <div className='msjUser'>
                                    <p>Hola</p>
                                    <div className='datosUser'>
                                        <img src={IconInfoUser} alt='infoUser'/>
                                        <p>5:30</p>
                                    </div>
                                </div>
                                <div className='msjBot'>
                                    <img src={LogoBot} alt='iconBot'/>
                                    <p>¡Bienvenido, soy Pablo! En qué le puedo ayudar?</p>
                                    <div className='datosBot'>
                                        <p>5:30</p>
                                    </div>
                                </div>
                                <div className='msjUser'>
                                    <p>si, que productos ofrecen?</p>
                                    <div className='datosUser'>
                                        <img src={IconInfoUser} alt='infoUser'/>
                                        <p>5:30</p>
                                    </div>
                                </div>
                                <div className='msjBot'>
                                    <img src={LogoBot} alt='iconBot'/>
                                    <p>Ofrecemos los siguientes tipos de Créditos:</p>
                                    <ul>
                                        <li>Hipotecario</li>
                                        <li>Personal</li>
                                        <li>Rotativo</li>
                                    </ul>
                                    <p>En que tipo de crédito está interesado?</p>
                                    <div className='datosBot'>
                                        <p>5:30</p>
                                    </div>
                                </div>
                                <div className='msjUser'>
                                    <p>Personal</p>
                                    <div className='datosUser'>
                                        <img src={IconInfoUser} alt='infoUser'/>
                                        <p>5:30</p>
                                    </div>
                                </div>
                                <div className='msjBot'>
                                    <img src={LogoBot} alt='iconBot'/>
                                    <p>Ha solicitado información del tipo de crédito personal. Para poder atenderle mejor. Puede brindarme su nombre?</p>
                                    <div className='datosBot'>
                                        <p>5:30</p>
                                    </div>
                                </div>
                            </div>
                         </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Historial;